import { send } from '../../../../../../src/network';
import { type Cart } from '../../../../../../src/types/Cart';

const cartPath = (id: number) => {
  return `/api/v2/customers/${id}/cart/`;
};

interface Args {
  params: {
    inventory_date?: string;
    id: number;
  };
  headers?: RequestHeaders;
  queryParams?: {
    inventoryDate?: string;
  };
}

interface RequestHeaders {
  saladShooterStreamId?: string;
}

export async function getCart(args: Args) {
  const { params, headers = {}, queryParams = {} } = args;
  const { id } = params;
  const { inventoryDate } = queryParams;

  const headersObject: HeadersInit = {};

  if (headers.saladShooterStreamId) {
    headersObject['X-SaladShooter-Stream-ID'] = headers.saladShooterStreamId;
  }

  const query = new URLSearchParams();
  if (inventoryDate !== undefined) {
    query.append('inventory_date', inventoryDate);
  }

  return send<Cart>({
    method: 'GET',
    path: cartPath(id),
    headers: new Headers(headersObject),
    query: query,
  });
}
